import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { merge } from 'lodash';
import moment from 'moment';

import { formatDateTime } from '@utils/datetime';

import { selectCarPolicyClaim } from './selector';
import { FormValues, formValuesSchema } from './schema';

export const useInitialValues = () => {
  const { policy } = useSelector(selectCarPolicyClaim);
  const initialValues: FormValues = formValuesSchema.getDefault() as unknown as FormValues;

  return useMemo(() => {
    if (!policy) return;

    merge(initialValues, {
      policyHolder: policy.user.name,
      policyNumber: policy.policyNumber ?? '',
      policyOrderNumber: policy.orderNumber,
      policyExpiryDate: moment(new Date(formatDateTime(policy.endedAt))).format('YYYY-MM-DDTHH:mm'),
      mobileNumber: policy.user.mobileNumber ?? '',
      email: policy.user.email ?? '',
      paymentInfo: {
        beneficiaryName: policy.user.name,
      },
    });

    return initialValues;
  }, [policy]);
};
